// Slide-down success toast (ported from QuizzyLoot).
export default function Toast({ show, message }) {
  return (
    <div
      className={`fixed top-12 left-1/2 -translate-x-1/2 transition-all duration-700 z-[110] pointer-events-none ${
        show
          ? 'translate-y-0 opacity-100 scale-100'
          : '-translate-y-24 opacity-0 scale-90'
      }`}
    >
      <div className="bg-white text-black px-12 py-5 rounded-full font-black text-xs uppercase tracking-[0.3em] shadow-[0_40px_80px_rgba(255,255,255,0.2)] flex items-center gap-4 border border-white/50">
        <span className="text-2xl">💰</span> {message || 'Asset Credited'}
      </div>
    </div>
  );
}
